export default "__VITE_ASSET__Cv5lVtF1__"